// Minimal next/router shim for the standalone login widget bundle.
// The static host page is not a Next.js app, so we replace next/router
// with a stub that only covers what the login chain actually reads.

const Router = {
  get asPath(): string {
    if (typeof window === "undefined") return "/";
    return window.location.pathname + window.location.search;
  },
  get pathname(): string {
    if (typeof window === "undefined") return "/";
    return window.location.pathname;
  },
  get query(): Record<string, string> {
    if (typeof window === "undefined") return {};
    const out: Record<string, string> = {};
    new URLSearchParams(window.location.search).forEach((v, k) => {
      out[k] = v;
    });
    return out;
  },
  reload(): void {
    if (typeof window !== "undefined") window.location.reload();
  },
  push(url: string): Promise<boolean> {
    if (typeof window !== "undefined") window.location.assign(url);
    return Promise.resolve(true);
  },
  replace(url: string): Promise<boolean> {
    if (typeof window !== "undefined") window.location.replace(url);
    return Promise.resolve(true);
  },
  back(): void {
    if (typeof window !== "undefined") window.history.back();
  },
  prefetch(): Promise<void> {
    return Promise.resolve();
  },
  events: {
    on(): void {},
    off(): void {},
    emit(): void {},
  },
};

export const useRouter = (): typeof Router => Router;
export const withRouter = <P>(C: P): P => C;
export default Router;
export { Router };
